import { types, actions } from './requests'
export const UPDATEWORKER_TYPES = {
    ...types('UPDATEWORKER'),
}
export const UPDATEWORKER_ACTIONS = {
    ...actions('UPDATEWORKER'),
}
